module.exports = __webpack_public_path__ + "img/sustainability.d7b13a65.jpg";